import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, TimeStepData } from '@packages/shared/core/quiz/entities';

type TimeQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const TimeQuizStep = ({ id, renderQuizScreen }: TimeQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as TimeStepData;

  const goBack = async () => back();

  const onTimeSelected = async (time?: string) => {
    updateUserPreferences(dataKey, time);
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onBack: goBack,
        onSelected: onTimeSelected,
        ...(stepData as TimeStepData),
      })}
    </>
  );
};

export default TimeQuizStep;
